import React from 'react';
import TrendTable from './Table';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import Visualis from './Visualis';
import { useIntl, getLocale } from 'umi';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    lineData,
    tableHeaderOptions,
    cardStatus,
    entityType,
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    baseReleaseTime,
    earliestPeriod,
    earliestDay,
    pageSortAttr,
    onTableSortChage,
    retentionMetricSource = 'appannie',
    lineSourceIcon = 'data.ai',
    trendLoading,
    enableOpinionEventAnnotation = false,
    controlledEventAnnotation,
  } = props;

  // console.log('TrendsCard', props);

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const { isLoading, isError, isNoData } = cardStatus || {};

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={`${formatMessage({ id: 'dbi_monthly_retention' })}${locale === 'zh-CN' ? '' : ' '}${formatMessage({ id: `dbi_detail_trend` })}`}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-trends-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={`${formatMessage({ id: 'dbi_monthly_retention' })}${locale === 'zh-CN' ? '' : ' '}${formatMessage({ id: `dbi_detail_trend` })}`}
        rightText={earliestDay ? `${formatMessage({ id: `dbi_detail_earliest_date` })}: ${earliestDay}` : ''}
        rightTip={earliestDay ? formatMessage({ id: `dbi_detail_earlistdate_info` }) : ''}
        disableChartType={['bar', 'pie']}
        activeTab={'line'}
      >
        <div className="trends-card-line">
          <Visualis
            lineData={lineData}
            dateType={dateType}
            baseReleaseTime={baseReleaseTime}
            earliestPeriod={earliestPeriod}
            secondTitleRight={formatMessage({ id: 'dbi_monthly_retention' })}
            lineSourceIcon={lineSourceIcon}
            trendLoading={trendLoading}
            enableOpinionEventAnnotation={enableOpinionEventAnnotation}
            controlledEventAnnotation={controlledEventAnnotation}
          />
        </div>
        <TrendTable
          entityType={entityType}
          gameName={gameName}
          gameCover={gameCover}
          dateType={dateType}
          startDate={startDate}
          endDate={endDate}
          tableData={tableData}
          tableHeaderOptions={tableHeaderOptions}
          pageSortAttr={pageSortAttr}
          onTableSortChage={onTableSortChage}
          retentionMetricSource={retentionMetricSource}
        />
      </CardSlotV2>
    </div>
  );
};

export default TrendsCard;
